/**
 * Money-page doors (Brief 17, 2026-10-23).
 *
 * Nine pages that convert or rank had zero or one hub link: no chrome door,
 * no footer door, no hub-page door. This module types each door once so the
 * top bar, Menu+, the footer and the /housing-market hub read the same href
 * and label. Labels carry no figures and no market-condition wording; every
 * stat on the destination pages stays engine-filled from live data.
 *
 * The three town market reports (Madras, Culver, Powell Butte) render from
 * live Market Truth rows through the /housing-market/[...slug] route. They are
 * not core report cities, so they are not on the Market top panel (that panel
 * is locked to lib/market/report-doors.ts) and are listed in the sitemap from
 * TOWN_MARKET_REPORT_PATHS rather than CORE_CITY_SLUGS.
 */
import type { NavLink } from '@/lib/site-nav'

export const FIRST_TIME_BUYER_DOOR: NavLink = {
  href: '/buy/first-time-home-buyer',
  label: 'First-time buyers',
}

export const OUT_OF_STATE_DOOR: NavLink = {
  href: '/cities/bend/from-out-of-state',
  label: 'Moving to Bend from out of state',
}

/** Luxury = $2M+ (LUXURY_MIN_PRICE); the over-2m preset is that floor. */
export const BEND_OVER_2M_DOOR: NavLink = {
  href: '/homes-for-sale/bend/over-2m',
  label: 'Bend homes $2M+',
}

export const BEND_ACREAGE_DOOR: NavLink = {
  href: '/homes-for-sale/bend/acreage',
  label: 'Bend homes on acreage',
}

export const AWBREY_BUTTE_DOOR: NavLink = {
  href: '/cities/bend/awbrey-butte',
  label: 'Awbrey Butte',
}

export const SELLER_GUIDE_DOOR: NavLink = {
  href: '/sell/guide',
  label: "Seller's guide",
}

/** Buyer doors in the order the Buy panels list them. */
export const BUYER_MONEY_DOORS: readonly NavLink[] = [
  FIRST_TIME_BUYER_DOOR,
  OUT_OF_STATE_DOOR,
  BEND_OVER_2M_DOOR,
  BEND_ACREAGE_DOOR,
]

/**
 * Town market reports outside the core report set. Labels never read
 * "{Town} housing market" (SITE-157 keeps that phrase off the footer).
 */
export const TOWN_MARKET_DOORS: readonly NavLink[] = [
  { href: '/housing-market/madras', label: 'Madras market' },
  { href: '/housing-market/culver', label: 'Culver market' },
  { href: '/housing-market/powell-butte', label: 'Powell Butte market' },
]

export const TOWN_MARKET_REPORT_PATHS: readonly string[] = TOWN_MARKET_DOORS.map((d) => d.href)

/** Every page this brief links, for the hub-link coverage test. */
export const MONEY_PAGE_PATHS: readonly string[] = [
  AWBREY_BUTTE_DOOR.href,
  BEND_OVER_2M_DOOR.href,
  BEND_ACREAGE_DOOR.href,
  OUT_OF_STATE_DOOR.href,
  FIRST_TIME_BUYER_DOOR.href,
  SELLER_GUIDE_DOOR.href,
  ...TOWN_MARKET_REPORT_PATHS,
]
